import { cn } from '@/utils/cn'

export function Skeleton({ className }) {
  return (
    <div
      className={cn(
        'animate-pulse-soft rounded-lg bg-gradient-to-r from-charcoal-100 via-sand-200 to-charcoal-100 bg-[length:200%_100%]',
        className
      )}
    />
  )
}

export function ProductCardSkeleton() {
  return (
    <div className="space-y-3">
      <Skeleton className="aspect-square w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-1/2" />
      <Skeleton className="h-5 w-1/3" />
    </div>
  )
}
